import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ExpertFollowup from "@/pages/ExpertFollowup";

export const Route = createFileRoute("/expert-followup/$token")({
  head: ({ params }) => seoHead(`/expert-followup/${params.token}`),
  component: ExpertFollowup,
});
